import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import SinglePlayer from "./components/SinglePlayer";
import Multiplayer from "./components/Multiplayer";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/single-player" element={<SinglePlayer />} />
          <Route path="/multiplayer" element={<Multiplayer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
